module.exports = __webpack_public_path__ + "img/empty.7ddf19a5.png";